export const version = "signing-key/5.6.0";
